module.exports = __webpack_public_path__ + "static/media/ic_proyectos_aereo_pin_seleccionado.504464e2.svg";